export const PRICE_TYPES_MAP = {
    MDV_PRICE: 'optin',
    SALE_PRICE: 'sale',
    BASE_PRICE: 'base',
    RECOMMENDED_PRICE: 'previous'
};

export const PRICE_TYPES_ORDER = [
    PRICE_TYPES_MAP.MDV_PRICE,
    PRICE_TYPES_MAP.SALE_PRICE,
    PRICE_TYPES_MAP.RECOMMENDED_PRICE,
    PRICE_TYPES_MAP.BASE_PRICE
];

export const ACTION_BUTTONS_POSITION = {
    FLOAT: 'float',
    DESCRIPTION_RIGHT: 'description-right',
    DESCRIPTION_BOTTOM: 'description-bottom'
};

export const PRICE_STRUCTURE = {
    SINGLE: 'single',
    FULL: 'full'
};

export const CARD_TYPES = {
    listingPage: 'listingPage',
    beautyBestSeller: 'beautyBestSeller',
    frontPageCarousel: 'frontPageCarousel',
    recentlyViewedPDP: 'recentlyViewedPDP',
    RFListingLeftSticky: 'RFListingLeftSticky',
    RFListingRightSticky: 'RFListingRightSticky',
    horizontalStickyRF: 'horizontalStickyRF',
    upsell: 'upsell',
    sizePicker: 'sizePicker',
    outOfStockItem: 'outOfStockItem',
    combineWith: 'combineWith',
    relatedItems: 'relatedItems',
    myListDesktop: 'myListDesktop',
    myListMobile: 'myListMobile',
    shareCollectionDesktop: 'shareCollectionDesktop',
    shareCollectionMobile: 'shareCollectionMobile',
    addFromFavourite: 'addFromFavourite',
    oosSubscribe: 'oosSubscribe',
    addCollectionToCart: 'addCollectionToCart',
    giftShop: 'giftShop',
    alternativeItems: 'alternativeItems'
};

const CARD_ORIENTATION = { vertical: 'vertical', horizontal: 'horizontal' };
const CARD_SIZE = { small: 'small', large: 'large' };

export const CARD_TYPES_ATTRIBUTES = {
    listingPage: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        showSustainabilityAttributes: true,
        showAlternativeImage: true,
        showSplashes: true,
        showImageSplashes: true,
        showDiscountSplashes: true,
        hasHoverEffect: true,
        showColors: true,
        showSizes: true,
        showSizesOnHover: true,
        actionButtonsPosition: ACTION_BUTTONS_POSITION.FLOAT,
        showMobileImagesCarousel: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    beautyBestSeller: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        showSustainabilityAttributes: true,
        showSplashes: true,
        showImageSplashes: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    frontPageCarousel: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        showSustainabilityAttributes: true,
        showSplashes: true,
        showImageSplashes: true,
        showDiscountSplashes: true,
        hideProductName: true,
        showColors: true,
        actionButtonsPosition: ACTION_BUTTONS_POSITION.FLOAT,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    recentlyViewedPDP: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.small,
        showDiscountSplashes: true,
        hideFavoriteButton: true,
        hideProductName: true,
        hasSimplePrice: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    RFListingLeftSticky: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.small,
        showDiscountSplashes: true,
        hideFavoriteButton: true,
        hideProductName: true,
        hasSimplePrice: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    RFListingRightSticky: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.small,
        hideFavoriteButton: true,
        hideProductName: true,
        hasSimplePrice: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    horizontalStickyRF: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.small,
        hideFavoriteButton: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    upsell: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hideColors: true,
        showSizes: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    sizePicker: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hideColors: true,
        floatPriceToRight: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    outOfStockItem: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hideColors: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    relatedItems: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        showSustainabilityAttributes: true,
        showSplashes: true,
        showImageSplashes: true,
        showDiscountSplashes: true,
        actionButtonsPosition: ACTION_BUTTONS_POSITION.FLOAT,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    myListDesktop: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.small,
        showDiscountSplashes: true,
        hideProductName: true,
        hasSimplePrice: true,
        hasToIncludeBasePrice: true,
        showColors: true,
        showSizes: true,
        showSplashes: true,
        showImageSplashes: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    myListMobile: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hasSimplePrice: true,
        showSizes: true,
        showColors: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    combineWith: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hideColors: true,
        showSizes: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    shareCollectionDesktop: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        hideColors: true,
        hideProductName: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    shareCollectionMobile: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        showSizes: true,
        showColors: false,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    addFromFavourite: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hasSimplePrice: true,
        hideColors: true,
        showSizes: true,
        priceStructure: PRICE_STRUCTURE.SINGLE
    },
    oosSubscribe: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        hideColors: true,
        hasSimplePrice: true,
        showQuantity: false,
        hideFavoriteButton: true,
        hasSingleItemData: true,
        showColors: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    addCollectionToCart: {
        orientation: CARD_ORIENTATION.horizontal,
        size: CARD_SIZE.small,
        floatPriceToRight: true,
        hasSimplePrice: true,
        showSizes: false,
        hideColors: true,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    giftShop: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        showSustainabilityAttributes: false,
        showIsInStockAttributes: false,
        showAlternativeImage: false,
        showImageSplashes: false,
        showSplashes: false,
        showDiscountSplashes: false,
        hasHoverEffect: true,
        showColors: false,
        priceStructure: PRICE_STRUCTURE.FULL
    },
    alternativeItems: {
        orientation: CARD_ORIENTATION.vertical,
        size: CARD_SIZE.large,
        actionButtonsPosition: ACTION_BUTTONS_POSITION.FLOAT,
        priceStructure: PRICE_STRUCTURE.FULL
    }
};

export const MEDIA_TYPE = {
    alternativeImage: 'alternative_image',
    video: 'video'
};

export const SPLASHES_TYPES = {
    TEXT: 'text',
    DISCOUNT: 'sale'
};

export const MAX_CAROUSEL_IMAGES = 5;
